var render = function render(){
  var _vm$content, _vm$content$justifica, _vm$content2, _vm$content2$justific;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "700"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.isView ? " Detalhar Reprovação" : " Reprovar Formação") + " ")])]), _c('div', {
    staticClass: "container dialog"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-2"
  }, [_c('v-col', {
    staticClass: "d-block",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    staticStyle: {
      "line-height": "1rem",
      "font-weight": "500"
    },
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v(" " + _vm._s(_vm.isView ? "Justificativa" : "Justificativa de reprovação*") + " ")]), _c('v-textarea', {
    attrs: {
      "id": "justificativa",
      "counter": !_vm.isView ? 400 : false,
      "maxlength": "400",
      "outlined": "",
      "dense": "",
      "disabled": _vm.isView,
      "rules": [_vm.$required]
    },
    model: {
      value: _vm.form.justificativaReprovacao,
      callback: function ($$v) {
        _vm.$set(_vm.form, "justificativaReprovacao", $$v);
      },
      expression: "form.justificativaReprovacao"
    }
  })], 1)], 1), _vm.isView ? _c('small', {
    staticClass: "font-weight-bold d-block",
    staticStyle: {
      "margin-top": "-2rem"
    }
  }, [_vm._v("Reprovado por: " + _vm._s((_vm$content = _vm.content) === null || _vm$content === void 0 ? void 0 : (_vm$content$justifica = _vm$content.justificativaReprovacao) === null || _vm$content$justifica === void 0 ? void 0 : _vm$content$justifica.usuario) + " em " + _vm._s((_vm$content2 = _vm.content) === null || _vm$content2 === void 0 ? void 0 : (_vm$content2$justific = _vm$content2.justificativaReprovacao) === null || _vm$content2$justific === void 0 ? void 0 : _vm$content2$justific.data))]) : _vm._e()], 1) : _vm._e()], 1), !_vm.isView ? _c('sigfoco-buttons', {
    attrs: {
      "actionText": 'Reprovar'
    },
    on: {
      "click": function ($event) {
        return _vm.reprovar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }) : _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }